
import { Info } from "lucide-react";

const NoEmailWarning = () => {
  return (
    <div className="flex items-start p-4 border border-amber-200 rounded-md bg-amber-50 mt-4">
      <Info className="h-5 w-5 text-amber-500 mt-0.5 flex-shrink-0" />
      <div className="ml-2">
        <p className="text-sm text-amber-800">
          No email address found. Please update your profile with an email address to receive notifications.
        </p>
      </div>
    </div>
  );
};

export default NoEmailWarning;
